module.exports = __webpack_public_path__ + "static/flags/GJ-c785b6ac10058a4da849711e16b4b447.gif";